import React , { Component } from 'react';
import { injectIntl } from 'react-intl';
import HelpStore from '../store/HelpStore';
import ReactMarkdown from 'react-markdown';
import TetherComponent from 'react-tether';
import Radium from 'radium';
import {spring} from 'react-motion';
import {ReactMotionLoop} from 'react-motion-loop';

const defaultGuideStyle =  {
  background:'rgb(105,105,105)',
  zIndex:'9999',
  width:'350px',
  opacity:'.99',
  color:"white",
  margin:'10px',
  padding:'10px',
  //borderRadius:'5px'
};





// Mi permette di definire meglio la struttura interna della guida eventuali estensioni
const defaultButtonStyle = {color:'green', cursor:'pointer'};

const HelpableContainer = (props) => {

  return (
        <div>
          {props.children}
        </div>
  )
}

class Helpable extends Component {

  constructor(props) {
    super(props);
    this.storeCallback = this.storeCallback.bind(this);
    this.handler=this.handler.bind(this);
    this.state = {
      enabled:false || HelpStore.isHelpEnabled(),
      showHelp:false
    }
  }

  handler(value) {
      this.setState({showHelp:value});
  }


  storeCallback() {
    if (HelpStore.isHelpEnabled() !== this.state.enabled) {
      this.setState({enabled:HelpStore.isHelpEnabled()});
    }
  }

  componentDidMount() {
    HelpStore.addChangeListener(this.storeCallback);
  }

  componentWillUnmount() {
    HelpStore.removeChangeListener(this.storeCallback);
  }

  render() {
    const { formatMessage } = this.props.intl;
    // Costruzione delle
    let iconId = this.props.bind+"-icon";
    let iconRef = "#"+this.props.bind+"-icon";
    let helpRef = "#"+this.props.bind;
    //let msgRef = this.props.context.paramContext.kind+"."+currentStep.description+".guide";
    let guideRef = this.props.guideRef;
    let desc = formatMessage({id:guideRef});
    let mdGuide = <ReactMarkdown source={desc}/>;
    let iconPosition = this.props.iconPosition || "top center";

    return (
	     <TetherComponent attachment="middle left"
	        targetAttachment={iconPosition}
	        renderElementTo={helpRef}
          style={{zIndex:'1230'}}>
	         {this.props.children}
	         {this.state.enabled && this.props.enabled &&
             <a onMouseOver={this.handler.bind(this,true)} onMouseLeave={this.handler.bind(this,false)} style={this.props.buttonStyle || defaultButtonStyle}>
	              <TetherComponent
	                 attachment={this.props.attachment || "middle left"} renderElementTo={iconRef} style={this.props.style || defaultGuideStyle }>
                   <ReactMotionLoop
                       styleFrom={{opacity: (this.state.showHelp?1:0.2) ,fontSize:20  }} // Instantly jump to the initial style
                       styleTo={{opacity: spring(1) , fontSize:20}}>
                       {style => <i id={iconId} className="fa fa-question-circle" style={style}></i>}
                       </ReactMotionLoop>
	                  {this.state.showHelp && <HelpableContainer>{mdGuide}</HelpableContainer>}
                </TetherComponent>
              </a>
            }
	      </TetherComponent>
    )
  }
}

// Specifies the default values for props:
Helpable.defaultProps = {
  enabled: true
};

export default Radium(injectIntl(Helpable));



// WEBPACK FOOTER //
// ./src/components/Helpable.js